module.exports = __webpack_public_path__ + "static/img/totop.c7cbf57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/totop.png
// module id = h9mv
// module chunks = 1